import React from "react";

const DateTabs = ({ dateFilter, setDateFilter }) => {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "10px",
        marginLeft: "20px",
        flex: 1,
      }}
    >
      <div
        onClick={() => setDateFilter("before")}
        style={{
          cursor: "pointer",
          padding: "12px 10px",
          fontWeight: dateFilter === "before" ? "600" : "500",
          color: dateFilter === "before" ? "#1890ff" : "#595959",
          borderBottom:
            dateFilter === "before"
              ? "3px solid #1890ff"
              : "3px solid transparent",
          transition: "all 0.3s ease",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flex: 1,
          gap: "8px",
        }}
      >
        <span>📅</span> Before August (Up to 31 July)
      </div>

      <div
        onClick={() => setDateFilter("after")}
        style={{
          cursor: "pointer",
          padding: "12px 10px",
          fontWeight: dateFilter === "after" ? "600" : "500",
          color: dateFilter === "after" ? "#1890ff" : "#595959",
          borderBottom:
            dateFilter === "after"
              ? "3px solid #1890ff"
              : "3px solid transparent",
          transition: "all 0.3s ease",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flex: 1,
          gap: "8px",
        }}
      >
        <span>📅</span> From August Onwards
      </div>
    </div>
  );
};

export default DateTabs;
